import {
  DialogContent as MuiDialogContent,
  type DialogContentProps as MuiDialogContentProps
} from '@mui/material';

export type DialogContentProps = MuiDialogContentProps;

export const DialogContent = (props: Readonly<DialogContentProps>) => (
  <MuiDialogContent {...props} />
);
